<script>
    import {createEvent} from "shared/eventBus";
    
    export default {
        props: {
            items: Array,
            value: String | Number,
            name: String,
            disabled: Boolean,
            height: {
                type: String,
                default: "38px"
            },
            width: {
                type: String,
                default: "100%"
            },
            saved: Boolean
        },
        data() {
            return {
                selectedValue: null,
                isNumber: false,
                changed: false
            }
        },
        methods: {
            flip() {
                var classList = this.$refs.flipImg.classList;
                classList.toggle('unflip180');
                classList.toggle('flip180');
            },
            unFlip() {
                var classList = this.$refs.flipImg.classList;
                classList.add('unflip180');
                classList.remove('flip180');
            },
            valueChanged(value) {
                this.selectValue(value);
                if(this.isNumber) {
                    value = Number(value);
                }
                this.$emit('selected', value);
                this.$emit('input', value);
                this.$emit('change', value);

                this.changed = true;

                this.$el.dispatchEvent(createEvent("change"));
            },
            selectValue(val) {
                this.selectedValue = val;
            }
        },
        mounted() {
            this.isNumber = typeof(this.value) === "number";
            this.selectValue(this.value);
        },
        watch: {
            value(val) {
                this.isNumber = typeof(val) === "number";
                this.selectValue(val);
            },
            saved(val) {
                if(val) {
                    this.changed = false;
                }
            }
        }
    }
</script>

<template>
    <div ref="container" class="select-container" :disabled="disabled" :style="{ height: height, width: width }" :class="{ changed: changed }">
        <select data-cs-mask ref="select" :name="name" v-model="selectedValue" @click="flip" @blur="unFlip"
            @change="valueChanged($event.target.value)" :disabled="disabled" :class="{ 'disabled-select': disabled }">
            <slot></slot>
            <option data-cs-mask v-for="item in items" :value="item.value" :key="item.value" :aria-label="item.ariaLabel">{{item.text}}</option>
        </select>
        <span ref="flipImg" class="select-arrow unflip180" :style="{ height: height, width: height }">
            <i class="arrow"></i>
        </span>
    </div>
</template>

<style lang="less" scoped>
    @import "~less-variables";
    @import "~less-mixins";

    .select-container {
        position: relative;
        width: 100%;
        
        select::-ms-expand {
            display: none;
        } 
        
        select {
            cursor: pointer;
            -webkit-appearance: none;
            -moz-appearance: none;
            appearance: none;
            border: 1px solid @frontier-responsive-gray;
            text-indent: 1px;
            text-overflow: '';
            width: 100%;
            height: 100%;
            padding-left: 10px;
            padding-top: 9px;
            padding-bottom: 7px;
            padding-right: 30px;
            font-family: @frontierFontFamily;
            font-size: 16px;
            background-color: white; 
            @media @Firefox {
                padding-top: 6px;
                padding-bottom: 5px;
            }
        }

        .select-arrow {
            position: absolute;
            right: 0;
            top: 0;
            text-align: center;
            z-index: 1;
            line-height: 38px;
            pointer-events: none;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;

            .arrow {
                .arrow-down(5px, 8px, @frontier-green);
            }
        }

        .flip180 {
            .rotate(180deg);
            transition: transform 300ms ease-in-out;
        }

        .unflip180 {
            .rotate(360deg);
            transition: transform 300ms ease-in-out;
        }

        &[disabled] {
            cursor: default;

            .arrow {
                display: none;
            }
        }

        .disabled-select {
            opacity: 1;
            color: @ibe-text--dark-gray;
            background-color: @inputDisabledBackground;
            font-weight: 500;
        }
    }
</style>